export default __webpack_public_path__ + "static/media/Sepet-Light.0a2876fb.png";